import { createUseStyles } from 'react-jss';

export const jobsTableStyles = createUseStyles({
  container: {

  },
});
